module.exports = __webpack_public_path__ + "img/902-03a51e.png";